import { render, staticRenderFns } from "./splitBar.vue?vue&type=template&id=766783d2&scoped=true"
import script from "./splitBar.vue?vue&type=script&lang=js"
export * from "./splitBar.vue?vue&type=script&lang=js"
import style0 from "./splitBar.vue?vue&type=style&index=0&id=766783d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766783d2",
  null
  
)

export default component.exports